import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { HelionButton } from "@components/ui/HelionButton";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await fetch("/.auth/me");
        const json = await res.json();
        const clientPrincipal = json.clientPrincipal;

        if (clientPrincipal) {
          const redirectPath = location.state?.from?.pathname || "/leaps";
          window.location.href = redirectPath;
        } else {
          setChecking(false);
        }
      } catch (err) {
        console.error("Login check failed", err);
        setChecking(false);
      }
    };

    checkAuth();
  }, [location.state]);

  const handleLogin = () => {
    window.location.href = "/.auth/login/aad";
  };

  if (checking) {
    return (
      <p className="text-center mt-12 text-[var(--text-secondary)]">
        Checking login status…
      </p>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-[var(--bg-primary)]">
      <h1 className="text-3xl font-bold mb-6 text-[var(--text-primary)]">
        Welcome to the Helion Dashboard
      </h1>

      <HelionButton
        onClick={handleLogin}
        className="px-6 py-2"
      >
        Sign in with Microsoft
      </HelionButton>
    </div>
  );
};

export default Login;